import { timelineClasses, timelineItemClasses } from '@mui/lab'
import { Box } from '@mui/material'
import useStyles from '~/common/hooks/useStyles'
import { ActivityItem } from './ActivityTimeline/ActivityItem'
import { PaginatedNotificationEvent } from './types'

function getStyles() {
  return {
    root: {
      [`& .${timelineItemClasses.root}:before`]: {
        flex: 0,
        padding: 0,
      },
      [`& .${timelineClasses.positionRight}`]: {
        flex: 0,
        flexGrow: 0,
      },
      margin: 0,
      // Set the min width to match the snackbar width
      minWidth: '288px',
    },
  }
}

interface ActivityPushNotificationProps {
  event: PaginatedNotificationEvent
}

/**
 * Renders the item for a push notification the user sees
 */
export function ActivityPushNotification({ event }: ActivityPushNotificationProps) {
  const styles = useStyles(getStyles)

  return (
    <Box sx={styles.root}>
      <ActivityItem activity={event} />
    </Box>
  )
}
